export const ANCHOR = {
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: 'center',
  BOTTOM: 'bottom',
  TOP: 'top',
  TOPLEFT: 'top-left',
  BOTTOMRIGHT: 'bottom-right',
};

export function getElementCoordinates(elementOrSelector, anchor) {
  const element =
    typeof elementOrSelector == 'string'
      ? document.querySelector(elementOrSelector)
      : elementOrSelector;

  if (!element) return { x: window.innerWidth / 2, y: window.innerHeight / 2 };
  const { x, y, width, height } = element.getBoundingClientRect();
  const origin = {
    [ANCHOR.LEFT]: { x, y: y + height / 2 },
    [ANCHOR.RIGHT]: { x: x + width, y: y + height / 2 },
    [ANCHOR.TOP]: { x: x + width / 2, y },
    [ANCHOR.BOTTOM]: { x: x + width / 2, y: y + height },
    [ANCHOR.CENTER]: { x: x + width / 2, y: y + height / 2 },
    [ANCHOR.TOPLEFT]: { x, y },
    [ANCHOR.BOTTOMRIGHT]: { x: x + width, y: y + height },
  }[anchor];
  return origin;
}
